import { Colors } from "../preset.constants";

export const multiselectPreset = {
    root: {
        background: Colors.PrimaryBackground,
        disabledBackground: Colors.DisabledBackground,
        filledBackground: Colors.PrimaryBackground,
        filledHoverBackground: Colors.PrimaryBackground,
        color: Colors.DefaultTextColor,
        disabledColor: Colors.DefaultTextColor,
    },
    dropdown: {
        background: Colors.PrimaryBackground,
        color: Colors.DefaultTextColor
    },
    overlay: {
        background: Colors.PrimaryBackground,
        color: Colors.DefaultTextColor
    },
    option: {
        color: Colors.DefaultTextColor
    }
}